var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"inpost",rawName:"v-inpost"}],attrs:{"id":"easypack-map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }